var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-container"},[_c('span',{on:{"click":function($event){_vm.isVisible = !_vm.isVisible}}},[_c('i',{staticClass:"fas fa-question-circle"})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade-fast"}},[(_vm.isVisible)?_c('div',{},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }